export enum OrderOverviewTestLabelEnum {
  STYLES_LBL = 'styles-lbl',
  ITEM_LIST_LBL = 'item-list-lbl',
}
